import React from 'react';
import './Why.css';

import balance_img from '../assets/icons/balance.svg';
import check_img from '../assets/icons/check.svg';
import map_img from '../assets/icons/map.svg';
import cash_img from '../assets/icons/cash.svg';
import lock_img from '../assets/icons/lock.svg';
import btc_img from '../assets/icons/btc.svg';


export const why = [
    {
        title: "Выгодный курс",
        description: "Конкурентные условия обмена и прозрачный расчёт без скрытых комиссий.",
        icon: balance_img,
    },
    {
        title: "Безопасная сделка",
        description: "Все условия фиксируются заранее, вы точно получаете то, о чём договорились.",
        icon: lock_img,
    },
    {
        title: "Офис в Перми",
        description: "Сделки проходят в нашем офисе — безопасно, удобно и конфиденциально.",
        icon: map_img,
    },
    {
        title: "Работа с наличными",
        description: "Основной формат обмена — наличные. Прозрачные условия и доступ к деньгам.",
        icon: cash_img,
    },
    {
        title: "Меняем BTC, ETH, Альты",
        description: "Мeняем USDT, BTC, ETH и Альткоины — быстро и по честному курсу.",
        icon: btc_img,
    },
];




const Why = () => {



    const handleClick = () => {
        const username = "obmenvpermi";
        const url = `https://t.me/${username}`;

        window.location.href = url;

        if (window.Telegram?.WebApp?.openTelegramLink) {
            window.Telegram.WebApp.openTelegramLink(url);
        }
    };


    return (
        <div className={'why-wrapper card'}>

            <h2 className={'uppercase'} style={{marginTop: '2px', marginBottom: '-2px'}}>
                Почему CashCoin?
            </h2>

            <div className={'why-container'}>
                {why.map((why, whyIndex) =>
                    <div className={'why-item'}>

                        <div className={'why-item-img-container'}>
                            <img className={'why-item-img'} src={why.icon} alt={why.title}/>
                        </div>

                        <div className={'why-item-text'}>
                            <h4 className={' uppercase'}>
                                {why.title}
                            </h4>

                            <p className={' opacity75'}>
                                {why.description}
                            </p>
                        </div>


                    </div>
                )}
            </div>

            <button onClick={() => handleClick()} className={'btn white-gradient full'}>
                Связаться с Нами
            </button>

        </div>
    );
};

export default Why;